import { DisplayNameSource } from 'graphql/generated/scheme'

interface DisplayNameUser {
	name?: string | null
	displayNameSource?: DisplayNameSource | null
	instagramDisplayName?: string | null
	tikTokDisplayName?: string | null
	twitchDisplayName?: string | null
}

export function resolveDisplayName(user?: DisplayNameUser | null): string | null | undefined {
	if (user?.displayNameSource === DisplayNameSource.Instagram && user.instagramDisplayName) {
		return user.instagramDisplayName
	}
	if (user?.displayNameSource === DisplayNameSource.TikTok && user.tikTokDisplayName) {
		return user.tikTokDisplayName
	}
	if (user?.displayNameSource === DisplayNameSource.Twitch && user.twitchDisplayName) {
		return user.twitchDisplayName
	}
	return user?.name
}
